import CryptoJS from 'crypto-js';
import { ModalComponent } from 'src/app/component/modal/modal.component';
import { ApiService } from 'src/app/services/api.service';
import { AuthService } from 'src/app/services/auth.service';
import { LoadingService } from 'src/app/services/loading.service';
import { NotificationService } from 'src/app/services/notification/notification.service';

import { Component, inject, OnInit, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
import { Network } from '@awesome-cordova-plugins/network/ngx';
import { SQLite, SQLiteObject } from '@awesome-cordova-plugins/sqlite/ngx';
import { StorageService } from '@core/services';
import { AlertController, IonRouterOutlet, ModalController, NavController, Platform } from '@ionic/angular';
import { ScannedResponse, ScanningModalComponent } from '@shared/components/scanning-modal/scanning-modal.component';

@Component({
  selector: 'app-scan',
  templateUrl: './scan-driver.page.html',
  styleUrls: ['./scan-driver.page.scss'],
})
export class ScanDriverPage implements OnInit {
  #notificationService = inject(NotificationService);
  id: number;
  user;
  scan;
  scanning = false;
  scanSub;
  flash = false;
  canFlash = false;
  camera = 0; // 0 = rear, 1 = front
  routes = [];
  route;
  bus;
  isOnline = false;
  type = 'bustickets';
  subscriptions;
  bustickets;
  realtrip;

  constructor(
    private authService: AuthService,
    private storage: StorageService,
    private apiService: ApiService,
    private platform: Platform,
    private modalCtrl: ModalController,
    private sqlite: SQLite,
    private network: Network,
    private alertCtrl: AlertController,
    private geolocation: Geolocation,
    private router: Router,
    private navCtrl: NavController,
    @Optional() private routerOutlet: IonRouterOutlet,
    private loadingService: LoadingService
  ) {}

  ngOnInit() {
    this.platform.ready().then(() => {
      this.authService.getUser().then((user) => {
        this.user = user;
      });

      this.storage.get('realtrip').then((realtrip) => {
        if (realtrip) {
          this.realtrip = realtrip;
          this.getBustickets();
          this.getSubscribers();
          this.initScan();
        } else {
          this.apiService
            .getData('transportec_realtrip')
            .then((res) => {
              console.log('realtrip: ', res);
              if (res && res.realtrip && res.realtrip.id) {
                this.realtrip = res.realtrip;
                this.getBustickets();
                this.getSubscribers();
                this.initScan();
              } else {
                this.simpleAlert(
                  'Alerta',
                  'Viaje no asignado o no pudo ser recuperado, favor de checar con el administrador.',
                  true
                );
              }
            })
            .finally(() => {});
        }
      });

      if (this.router.url.indexOf('exit') >= 0) {
        console.log('Entró exit scan!');
      }

      if (this.platform.is('cordova')) {
        this.sqlite.create({ name: 'tecservice.db', location: 'default' }).then((db: SQLiteObject) => {
          // db.executeSql('DROP TABLE IF EXISTS payments', {}).then(() => {});
          // db.executeSql('DROP TABLE users',[]);
          // Users
          db.executeSql(
            'CREATE TABLE IF NOT EXISTS subscriptions (id INTEGER PRIMARY KEY, dotw INTEGER, type TEXT, departure_time TEXT, route_id INTEGER, stop_id INTEGER, bus_id INTEGER, suscription_transportec_id INTEGER)',
            []
          )
            .then(() => {})
            .catch((e) => {
              this.simpleAlert('Error', 'Error SQL: ' + JSON.stringify(e));
              console.log(e);
            });

          db.executeSql(
            'CREATE TABLE IF NOT EXISTS scanned_subscriptions (id INTEGER PRIMARY KEY, realtrip_id INTEGER, scanned_at DATETIME, sent_at DATETIME)',
            []
          )
            .then(() => {})
            .catch((e) => {
              this.simpleAlert('Error', 'Error SQL: ' + JSON.stringify(e));
              console.log(e);
            });

          // db.executeSql('DROP TABLE payments',[]);
          // Pagos
          db.executeSql(
            'CREATE TABLE IF NOT EXISTS bustickets (id INTEGER PRIMARY KEY, amount REAL, method TEXT, scanned_at DATETIME, realtrip_id INTEGER, user_id INTEGER)',
            []
          )
            .then(() => {})
            .catch((e) => {
              this.simpleAlert('Error', 'Error SQL: ' + JSON.stringify(e));
              console.log(e);
            });

          db.executeSql(
            'CREATE TABLE IF NOT EXISTS scanned_bustickets (id INTEGER PRIMARY KEY, realtrip_id INTEGER, scanned_at DATETIME, sent_at DATETIME)',
            []
          )
            .then(() => {})
            .catch((e) => {
              this.simpleAlert('Error', 'Error SQL: ' + JSON.stringify(e));
              console.log(e);
            });
        });
      }

      // watch network for a disconnect
      this.network.onDisconnect().subscribe(() => {
        this.isOnline = false;
      });

      // watch network for a connection
      this.network.onConnect().subscribe(() => {
        if (!this.isOnline) {
          setTimeout(() => {
            /* this.sendToServer();
            this.updateUsers();*/
          }, 3000);
        }
        this.isOnline = true;
      });
    });
  }

  async getUser() {
    this.user = await this.authService.getUser();
  }

  getBustickets() {
    if (this.platform.is('cordova') && (this.isOnline || this.network.type !== 'none')) {
      this.apiService.getData('transportec_bustickets?realtrip_id=' + this.realtrip.id).then((res) => {
        if (res && res.data) {
          // this.simpleAlert("Info", "Recuperando de servidor " + users.data.length + " usuarios.");
          this.bustickets = res.data;
          this.sqlite
            .create({ name: 'tecservice.db', location: 'default' })
            .then((db: SQLiteObject) => {
              db.executeSql('DELETE FROM bustickets', [])
                .then((data) => {
                  for (let k = 0; k < res.data.length; k++) {
                    db.executeSql('INSERT OR IGNORE INTO bustickets VALUES (?,?,?,?,?,?)', [
                      res.data[k].id,
                      res.data[k].amount,
                      res.data[k].method,
                      res.data[k].scanned_at,
                      res.data[k].realtrip_id,
                      res.data[k].user_id,
                    ])
                      .then(() => {
                        if (k === res.data.length - 1) {
                          console.log('todos insertados');
                        }
                      })
                      .catch((e) => {
                        this.simpleAlert(
                          'Error',
                          'Error en insert busticket: ' + JSON.stringify(e) + ' ' + res.data[k].id
                        );
                      });
                  }
                })
                .catch((e) => {
                  this.simpleAlert('Error', 'Error en delete: ' + JSON.stringify(e));
                  console.log(e);
                });
            })
            .catch((e) => {
              this.simpleAlert('Error', 'Error en create: ' + JSON.stringify(e));
              console.log(e);
            });
        }
      });
    } else {
      if (this.platform.is('cordova')) {
        // this.getUsers();
      } else {
        this.apiService.getData('transportec_bustickets?realtrip_id=' + this.realtrip.id).then((res) => {
          console.log('bustickets: ', res);
          this.bustickets = res.data;
        });
      }
    }
  }

  getSubscribers() {
    if (this.platform.is('cordova') && (this.isOnline || this.network.type !== 'none')) {
      this.apiService.getData('suscribers?realtrip_id=' + this.realtrip.id).then((res) => {
        if (res && res.data) {
          // this.simpleAlert("Info", "Recuperando de servidor " + users.data.length + " usuarios.");
          this.subscriptions = res.data;
          this.sqlite
            .create({ name: 'tecservice.db', location: 'default' })
            .then((db: SQLiteObject) => {
              db.executeSql('DELETE FROM subscriptions', [])
                .then((data) => {
                  for (let k = 0; k < res.data.length; k++) {
                    db.executeSql('INSERT OR IGNORE INTO subscriptions VALUES (?,?,?,?,?,?,?,?)', [
                      res.data[k].id,
                      res.data[k].dotw,
                      res.data[k].type,
                      res.data[k].departure_time,
                      res.data[k].route_id,
                      res.data[k].stop_id,
                      res.data[k].bus_id,
                      res.data[k].suscription_transportec_id,
                    ])
                      .then(() => {
                        if (k === res.data.length - 1) {
                          console.log('todos insertados');
                        }
                      })
                      .catch((e) => {
                        this.simpleAlert(
                          'Error',
                          'Error en insert subscription: ' + JSON.stringify(e) + ' ' + res.data[k].id
                        );
                      });
                  }
                })
                .catch((e) => {
                  this.simpleAlert('Error', 'Error en delete: ' + JSON.stringify(e));
                  console.log(e);
                });
            })
            .catch((e) => {
              this.simpleAlert('Error', 'Error en create: ' + JSON.stringify(e));
              console.log(e);
            });
        }
      });
    } else {
      if (this.platform.is('cordova')) {
        // this.getUsers();
      } else {
        this.apiService.getData('suscribers?realtrip_id=' + this.realtrip.id).then((res) => {
          console.log('subscriptions: ', res);
          this.subscriptions = res.data;
        });
      }
    }
  }

  notAuthorized() {
    console.warn('Camera or Accounts permission is not turned on');
    this.navCtrl.back();
  }

  ionViewDidLeave() {
    this.scanning = false;
  }

  initScan() {
    this.platform.ready().then(() => {
      if (this.realtrip) {
        this.newScan();
      }
    });
  }

  async newScan() {
    try {
      this.scanning = true;
      const modal = await this.modalCtrl.create({
        component: ScanningModalComponent,
      });
      await modal.present();
      const { data } = await modal.onWillDismiss<ScannedResponse>();
      console.log('Scanned Data: ', data);
      this.scanning = false;
      if (data) {
        this.processScanText(data.code);
      } else {
        this.close();
      }
    } catch (error) {
      this.close();
    }
  }

  processScanText(text) {
    if (text) {
      const resArray = text.split('|');
      if (resArray.length === 5 && (resArray[0] === 'transportec-s' || resArray[0] === 'transportec-t')) {
        // QR válido, hay que checar si es de suscripción o de busticket
        if (resArray[0] === 'transportec-s') {
          this.type = 'subscriptions';
        } else {
          this.type = 'bustickets';
        }
        this.id = resArray[2];
        this.busdriverResponse(true);
      } else {
        this.busdriverResponse(false);
      }
    } else {
      this.simpleAlert('QR inválido', 'El código QR es inválido, favor de escanear el correcto.', true);
    }
  }

  search() {
    if (this.platform.is('cordova')) {
      this.sqlite.create({ name: 'tecservice.db', location: 'default' }).then((db: SQLiteObject) => {
        db.executeSql(
          'SELECT * FROM ' + this.type + ' WHERE id=?' + (this.type === 'bustickets' ? ' AND scanned_at IS NULL' : ''),
          [this.id]
        ).then((data) => {
          const len = data.rows.length;
          // Si existe el boleto o suscripción entonces checamos si no fue previamente escaneado
          if (len > 0) {
            console.log(data.rows.item(0));
            // this.savePayment();
            db.executeSql('SELECT * FROM scanned_' + this.type + ' WHERE id=?', [this.id]).then(() => {
              const leng = data.rows.length;
              // Si hay resultado quiere decir que ya fue escaneado, entonces rechazamos
              if (leng > 0) {
                // Existe, no guardar
                console.log(data.rows.item(0));
                this.busdriverResponse(false);
              } else {
                // No existe, guardar
                this.savePayment();
              }
            });
          } else {
            // No existe
            this.busdriverResponse(false);
          }
        });
      });
    }
  }

  async busdriverResponse(status) {
    if (this.router.url.indexOf('exit') >= 0) {
      // this.simpleAlert('Debug', 'go ExitTicket()', false);
      this.checkExitTicket();
    } else if (status) {
      if (this.platform.is('cordova')) {
        // this.simpleAlert('Debug', 'go Payment', false);
        if (this.isOnline || this.network.type !== 'none') {
          // this.simpleAlert('Debug', 'send', false);
          this.sendPayment();
        } else {
          // this.simpleAlert('Debug', 'save', false);
          this.search();
        }
      } else {
        console.log('Enviar pago directo a servidor?');
      }
    } else {
      this.goModal('error2');
    }
  }

  checkExitTicket() {
    const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
    const n = new Date(Date.now() - tzoffset).toISOString().slice(0, 19).replace('T', ' ');
    this.loadingService.present('Validando....');
    setTimeout(() => {
      this.loadingService.dismiss();
    }, 1000);
    this.apiService
      .postData('transportec_subscription-radial', {
        id: this.id,
        realtrip_id: this.realtrip.id,
        scanned_at: n,
        subscription: this.type === 'subscriptions',
      })
      .then((response) => {
        if (response.success) {
          this.goModal('success3');
          this.simpleAlert('Escaneo exitoso', '¡Gracias por su viaje!');
        } else {
          this.goModal('error2');
          this.simpleAlert('Error', 'Bajada incorrecta');
        }
      })
      .catch((error) => {
        this.simpleAlert('Error', 'Error al verificar QR con servidor. Intentar más tarde. Consulte al administrador.');
        this.busdriverResponse(false);
      })
      .finally(() => {
        this.loadingService.dismiss();
      });
  }

  sendPayment() {
    // this.simpleAlert('Debug', 'sending..', false);
    const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
    const n = new Date(Date.now() - tzoffset).toISOString().slice(0, 19).replace('T', ' ');
    this.loadingService.present('Validando... ');
    setTimeout(() => {
      this.loadingService.dismiss();
    }, 1000);
    const args = {
      id: this.id,
      realtrip_id: this.realtrip.id,
      scanned_at: n,
    };
    // this.simpleAlert('Debug', 'postData(\'transportec_\'' + this.type.slice(0, -1) + JSON.stringify(args), false);
    this.apiService
      .postData('transportec_' + this.type.slice(0, -1), args)
      .then((response) => {
        // this.simpleAlert('Response', + JSON.stringify(response), true);
        if (response.success) {
          // this.goModal('success2');
          this.savePayment(n);
        } else {
          this.busdriverResponse(false);
          if (response.error) {
            this.#notificationService.presentToast(response.error);
          }
        }
      })
      .catch((error) => {
        this.simpleAlert('Error', 'Error al verificar QR con servidor. Intentar más tarde. Consulte al administrador.');
        this.busdriverResponse(false);
      })
      .finally(() => {
        this.loadingService.dismiss();
      });
  }

  savePayment(sentAt = null) {
    // this.simpleAlert("Debug", "saving..", false);
    const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
    const n = new Date(Date.now() - tzoffset).toISOString().slice(0, 19).replace('T', ' ');
    this.loadingService.present('Guardando...');
    setTimeout(() => {
      this.loadingService.dismiss();
    }, 1000);
    this.sqlite
      .create({ name: 'tecservice.db', location: 'default' })
      .then((db: SQLiteObject) => {
        db.executeSql(
          'INSERT OR IGNORE INTO scanned_' + this.type + ' (id, realtrip_id, scanned_at, sent_at) VALUES (?,?,?,?)',
          [this.id, this.realtrip.id, n, sentAt]
        )
          .then((data) => {
            this.goModal('success2');
            this.loadingService.dismiss();
          })
          .catch((e) => {
            this.simpleAlert('Error', 'Error: ' + JSON.stringify(e));
          })
          .finally(() => {
            this.loadingService.dismiss();
          });
      })
      .finally(() => {
        this.loadingService.dismiss();
      });
  }

  async goModal(type, myContent = null) {
    const modal = await this.modalCtrl.create({
      component: ModalComponent,
      componentProps: {
        has_toolbar: false,
        bg_class: type,
        content: myContent,
      },
      cssClass: 'modal-fullscreen',
      keyboardClose: true,
      showBackdrop: true,
    });

    modal.onDidDismiss().then(() => {
      setTimeout(() => {
        this.initScan();
      }, 0);
    });

    return await modal.present();
  }

  async simpleAlert(title, message, closeAfterClick = false) {
    const alert = await this.alertCtrl.create({
      header: title,
      message,
      buttons: [
        {
          text: 'OK',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
            if (closeAfterClick) {
              this.close();
            }
          },
        },
      ],
    });
    alert.present();
  }

  close(status = null) {
    setTimeout(async () => {
      const isModalOpened = await this.modalCtrl.getTop();
      if (isModalOpened) {
        this.modalCtrl.dismiss();
      } else if (this.routerOutlet && this.routerOutlet.canGoBack()) {
        this.routerOutlet.pop();
      } else {
        this.navCtrl.navigateBack('/tecservice-driver/stops');
      }
    }, 800);
  }
}
